import { datadogLogs } from '@datadog/browser-logs'

const SKIP_ERROR_MESSAGES = ['Twilio 53118 - Room completed']
const MONITOR_PATH = '/monitor'

function shouldSkip(err) {
  return SKIP_ERROR_MESSAGES.includes(err) || SKIP_ERROR_MESSAGES.includes(err.message)
    || SKIP_ERROR_MESSAGES.includes(err.toString())
}

function isMonitor() {
  return window.location.hash.includes(MONITOR_PATH)
}

export function logError(err, customAttributes) {
  if (shouldSkip(err.message) || isMonitor()) return
  if (typeof datadogLogs !== 'undefined') {
    const msg = err.name ? `${err.name}: ${err.message}` : err.message
    datadogLogs.logger.error(msg, customAttributes, err)
  }
}

export class GVSAPICallError extends Error {
  constructor(url, method, status, response) {
    super(`API call error. URL: ${url}, method: ${method}, status: ${status}, response: ${JSON.stringify(response)}`)
    this.name = 'GVSAPICallError'
  }
}

export class WebsocketError extends Error {
  constructor(message) {
    super(message)
    this.name = 'WebsocketError'
  }
}

export class VignetteNotSupportedError extends Error {
  constructor(osFamily, osVersion) {
    super(`Vignette Visit Fail Start. OS: "${osFamily}", version: "${osVersion}". User Agent: "${window.navigator.userAgent}"`)
    this.name = 'VignetteNotSupportedError'
  }
}

export class FaceDetectionError extends Error {
  constructor(reason) {
    super(`${reason}. User Agent: "${window.navigator.userAgent}`)
    this.name = 'FaceDetectionError'
  }
}
